import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, ViewChild, ViewEncapsulation, Component } from '@angular/core';
import * as i7 from 'primeng/badge';
import { BadgeModule } from 'primeng/badge';
import * as i2 from 'primeng/button';
import { ButtonModule } from 'primeng/button';
import * as i4 from 'primeng/divider';
import { DividerModule } from 'primeng/divider';
import * as i5 from 'primeng/menubar';
import { MenubarModule } from 'primeng/menubar';
import * as i3 from 'primeng/api';
import * as i6 from '@angular/router';
const _c0 = ["searchBarHostElement"];
const _c1 = [[["", "search", ""]], [["", "iconsSlot", ""]]];
const _c2 = ["[search]", "[iconsSlot]"];
const _c3 = a0 => [a0];
function HeaderBarComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelement(1, "p-divider", 29);
    i0.ɵɵelementStart(2, "span", 30);
    i0.ɵɵlistener("click", function HeaderBarComponent_div_0_div_6_Template_span_click_2_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.industryNameClick($event));
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.industryName);
  }
}
function HeaderBarComponent_div_0_div_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HeaderBarComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵtemplate(1, HeaderBarComponent_div_0_div_7_ng_container_1_Template, 1, 0, "ng-container", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const searchTemplate_r4 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", searchTemplate_r4);
  }
}
function HeaderBarComponent_div_0_p_button_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 32);
    i0.ɵɵlistener("click", function HeaderBarComponent_div_0_p_button_10_Template_p_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleSearchBar());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 12);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", ctx_r1.searchLabel)("text", true);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#magnify");
  }
}
function HeaderBarComponent_div_0_p_button_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 33);
    i0.ɵɵlistener("click", function HeaderBarComponent_div_0_p_button_11_Template_p_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onProfileClick($event));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 12);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", ctx_r1.profileDisplayName)("text", true);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#account-circle-outline");
  }
}
function HeaderBarComponent_div_0_p_button_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 34);
    i0.ɵɵlistener("click", function HeaderBarComponent_div_0_p_button_12_Template_p_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onFavoritesClick($event));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 12);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", ctx_r1.favoritesLabel)("text", true);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#heart-outline");
  }
}
function HeaderBarComponent_div_0_p_button_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 35);
    i0.ɵɵlistener("click", function HeaderBarComponent_div_0_p_button_13_Template_p_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onBadgeClick($event));
    });
    i0.ɵɵelementStart(1, "i", 36);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 12);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", ctx_r1.cartLabel)("text", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r1.cartBadge);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#cart-outline");
  }
}
function HeaderBarComponent_div_0_p_button_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 37);
    i0.ɵɵlistener("click", function HeaderBarComponent_div_0_p_button_15_Template_p_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleSearchBar());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 12);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("text", true);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#magnify");
  }
}
function HeaderBarComponent_div_0_p_button_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 38);
    i0.ɵɵlistener("click", function HeaderBarComponent_div_0_p_button_16_Template_p_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onProfileClick($event));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 12);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("text", true);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#account-circle-outline");
  }
}
function HeaderBarComponent_div_0_p_button_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 39);
    i0.ɵɵlistener("click", function HeaderBarComponent_div_0_p_button_17_Template_p_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onFavoritesClick($event));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 12);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("text", true);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#heart-outline");
  }
}
function HeaderBarComponent_div_0_p_button_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 40);
    i0.ɵɵlistener("click", function HeaderBarComponent_div_0_p_button_18_Template_p_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onBadgeClick($event));
    });
    i0.ɵɵelementStart(1, "i", 36);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 12);
    i0.ɵɵelement(3, "use");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("text", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r1.cartBadge);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#cart-outline");
  }
}
function HeaderBarComponent_div_0_ng_container_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HeaderBarComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "p-button", 11);
    i0.ɵɵlistener("click", function HeaderBarComponent_div_0_Template_p_button_click_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onMenuToggle($event));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 12);
    i0.ɵɵelement(4, "use");
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(5, "img", 13);
    i0.ɵɵlistener("click", function HeaderBarComponent_div_0_Template_img_click_5_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.logoClick($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, HeaderBarComponent_div_0_div_6_Template, 4, 1, "div", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, HeaderBarComponent_div_0_div_7_Template, 2, 1, "div", 15);
    i0.ɵɵelementStart(8, "div", 16)(9, "div", 17);
    i0.ɵɵtemplate(10, HeaderBarComponent_div_0_p_button_10_Template, 3, 4, "p-button", 18)(11, HeaderBarComponent_div_0_p_button_11_Template, 3, 4, "p-button", 19)(12, HeaderBarComponent_div_0_p_button_12_Template, 3, 4, "p-button", 20)(13, HeaderBarComponent_div_0_p_button_13_Template, 4, 5, "p-button", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 22);
    i0.ɵɵtemplate(15, HeaderBarComponent_div_0_p_button_15_Template, 3, 3, "p-button", 23)(16, HeaderBarComponent_div_0_p_button_16_Template, 3, 3, "p-button", 24)(17, HeaderBarComponent_div_0_p_button_17_Template, 3, 3, "p-button", 25)(18, HeaderBarComponent_div_0_p_button_18_Template, 4, 4, "p-button", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(19, HeaderBarComponent_div_0_ng_container_19_Template, 1, 0, "ng-container", 27);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const iconsSlotTemplate_r13 = i0.ɵɵreference(7);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("text", true);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#menu");
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r1.logoSrc, i0.ɵɵsanitizeUrl)("alt", ctx_r1.logoAltText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.industryName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showSearch);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.showSearch);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showProfile);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showFavorites);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showCart);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showSearch);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showProfile);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showFavorites);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showCart);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", iconsSlotTemplate_r13);
  }
}
function HeaderBarComponent_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HeaderBarComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵtemplate(1, HeaderBarComponent_div_1_ng_container_1_Template, 1, 0, "ng-container", 27);
    i0.ɵɵelementStart(2, "p-button", 42);
    i0.ɵɵlistener("click", function HeaderBarComponent_div_1_Template_p_button_click_2_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleSearchBar());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 12);
    i0.ɵɵelement(4, "use");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const searchTemplate_r4 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", searchTemplate_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("text", true);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#close");
  }
}
function HeaderBarComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c3, "pds-header-menu-bar__" + ctx_r1.tabMenuVariant));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.industryName, "\n");
  }
}
function HeaderBarComponent_div_3_ng_template_2_ng_template_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HeaderBarComponent_div_3_ng_template_2_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 48);
    i0.ɵɵtemplate(1, HeaderBarComponent_div_3_ng_template_2_ng_template_0_ng_container_1_Template, 1, 0, "ng-container", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r15 = i0.ɵɵnextContext().$implicit;
    const menuItemTemplate_r16 = i0.ɵɵreference(5);
    i0.ɵɵpropertyInterpolate("target", item_r15.target);
    i0.ɵɵattribute("href", item_r15 == null ? null : item_r15.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", menuItemTemplate_r16);
  }
}
function HeaderBarComponent_div_3_ng_template_2_ng_template_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HeaderBarComponent_div_3_ng_template_2_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 49);
    i0.ɵɵtemplate(1, HeaderBarComponent_div_3_ng_template_2_ng_template_2_ng_container_1_Template, 1, 0, "ng-container", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r15 = i0.ɵɵnextContext().$implicit;
    const menuItemTemplate_r16 = i0.ɵɵreference(5);
    i0.ɵɵpropertyInterpolate("target", item_r15.target);
    i0.ɵɵproperty("routerLink", item_r15 == null ? null : item_r15.routerLink);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", menuItemTemplate_r16);
  }
}
function HeaderBarComponent_div_3_ng_template_2_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span");
    i0.ɵɵelementStart(1, "span", 50);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r15 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMap(item_r15.icon ? item_r15.icon + " p-menuitem-icon" : "");
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-test-id", item_r15.codename ? "menuItem." + item_r15.codename : "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r15.label);
  }
}
function HeaderBarComponent_div_3_ng_template_2_ng_container_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HeaderBarComponent_div_3_ng_template_2_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HeaderBarComponent_div_3_ng_template_2_ng_container_6_ng_container_1_Template, 1, 0, "ng-container", 27);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const externalLink_r17 = i0.ɵɵreference(1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", externalLink_r17);
  }
}
function HeaderBarComponent_div_3_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HeaderBarComponent_div_3_ng_template_2_ng_template_0_Template, 2, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(2, HeaderBarComponent_div_3_ng_template_2_ng_template_2_Template, 2, 3, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(4, HeaderBarComponent_div_3_ng_template_2_ng_template_4_Template, 3, 4, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(6, HeaderBarComponent_div_3_ng_template_2_ng_container_6_Template, 2, 1, "ng-container", 47);
  }
  if (rf & 2) {
    const item_r15 = ctx.$implicit;
    const internalLink_r18 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r1.isItemExternal(item_r15))("ngIfElse", internalLink_r18);
  }
}
function HeaderBarComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44)(1, "p-menubar", 45);
    i0.ɵɵtemplate(2, HeaderBarComponent_div_3_ng_template_2_Template, 7, 2, "ng-template", 46);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c3, "pds-header-menu-bar__" + ctx_r1.tabMenuVariant));
    i0.ɵɵadvance();
    i0.ɵɵproperty("model", ctx_r1.menuItems);
  }
}
function HeaderBarComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function HeaderBarComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
let HeaderBarComponent = /*#__PURE__*/(() => {
  class HeaderBarComponent {
    constructor() {
      this.profileDisplayName = '';
      this.showSearchBar = false;
      this.symbolsToCutLength = 15;
      this.logoSrc = '';
      this.tabMenuVariant = 'subtle';
      this.logoAltText = '';
      this.industryName = '';
      this.menuItems = [];
      this.showProfile = false;
      this.showFavorites = false;
      this.favoritesLabel = '';
      this.showCart = false;
      this.cartLabel = '';
      this.cartBadge = '';
      this.showSearch = true;
      this.searchLabel = '';
      this.menuToggle = new EventEmitter();
      this.profileClick = new EventEmitter();
      this.favoritesClick = new EventEmitter();
      this.badgeClick = new EventEmitter();
      this.onLogoClick = new EventEmitter();
      this.onIndustryNameClick = new EventEmitter();
      this.icons = 'assets/pds-icons.svg';
    }
    set profileName(name) {
      this.profileDisplayName = name?.length > this.symbolsToCutLength ? name.split(' ')[0] : name;
    }
    onMenuToggle(event) {
      this.menuToggle.emit(event);
    }
    onProfileClick(event) {
      this.profileClick.emit(event);
    }
    onFavoritesClick(event) {
      this.favoritesClick.emit(event);
    }
    onBadgeClick(event) {
      this.badgeClick.emit(event);
    }
    toggleSearchBar() {
      this.showSearchBar = !this.showSearchBar;
    }
    logoClick(event) {
      this.onLogoClick.emit(event);
    }
    industryNameClick(event) {
      this.onIndustryNameClick.emit(event);
    }
    isItemExternal(i) {
      return !!(i?.url && !i?.routerLink);
    }
    static {
      this.ɵfac = function HeaderBarComponent_Factory(t) {
        return new (t || HeaderBarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HeaderBarComponent,
        selectors: [["pds-header-bar"]],
        viewQuery: function HeaderBarComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchBarHostElement = _t.first);
          }
        },
        inputs: {
          logoSrc: "logoSrc",
          tabMenuVariant: "tabMenuVariant",
          logoAltText: "logoAltText",
          industryName: "industryName",
          menuItems: "menuItems",
          showProfile: "showProfile",
          profileName: "profileName",
          showFavorites: "showFavorites",
          favoritesLabel: "favoritesLabel",
          showCart: "showCart",
          cartLabel: "cartLabel",
          cartBadge: "cartBadge",
          showSearch: "showSearch",
          searchLabel: "searchLabel"
        },
        outputs: {
          menuToggle: "menuToggle",
          profileClick: "profileClick",
          favoritesClick: "favoritesClick",
          badgeClick: "badgeClick",
          onLogoClick: "onLogoClick",
          onIndustryNameClick: "onIndustryNameClick"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c2,
        decls: 8,
        vars: 4,
        consts: [["searchTemplate", ""], ["iconsSlotTemplate", ""], ["externalLink", ""], ["internalLink", ""], ["menuItemTemplate", ""], ["class", "pds-header-bar", 4, "ngIf"], ["class", "pds-header-search-bar", 4, "ngIf"], ["class", "pds-header-menu-bar pds-header-menu-bar-industry", 3, "ngClass", 4, "ngIf"], ["class", "pds-header-menu-bar pds-header-menu-bar-menu", 3, "ngClass", 4, "ngIf"], [1, "pds-header-bar"], [1, "pds-header-bar-left-container"], ["severity", "secondary", "size", "small", "aria-description", "menu", 3, "click", "text"], [1, "pds-icon"], [1, "pds-header-bar-logo", 3, "click", "src", "alt"], ["class", "pds-header-bar-industry-container", 4, "ngIf"], ["class", "pds-header-bar-center-container", 4, "ngIf"], [1, "pds-header-bar-right-container"], [1, "pds-header-bar-actions-container", "pds-header-bar-actions-container__long"], ["iconPos", "left", "styleClass", "pds-header-bar-search-button", 3, "label", "text", "click", 4, "ngIf"], ["iconPos", "left", "aria-description", "profile of", 3, "label", "text", "click", 4, "ngIf"], ["iconPos", "left", 3, "label", "text", "click", 4, "ngIf"], ["aria-description", "cart with items amount of", 3, "label", "text", "click", 4, "ngIf"], [1, "pds-header-bar-actions-container", "pds-header-bar-actions-container__short"], ["iconPos", "left", "size", "small", "styleClass", "pds-header-bar-search-button", 3, "text", "click", 4, "ngIf"], ["iconPos", "left", "size", "small", "aria-description", "profile of", 3, "text", "click", 4, "ngIf"], ["iconPos", "left", "size", "small", 3, "text", "click", 4, "ngIf"], ["size", "small", "aria-description", "cart with items amount of", 3, "text", "click", 4, "ngIf"], [4, "ngTemplateOutlet"], [1, "pds-header-bar-industry-container"], ["layout", "vertical"], [1, "pds-header-bar-industry-name", 3, "click"], [1, "pds-header-bar-center-container"], ["iconPos", "left", "styleClass", "pds-header-bar-search-button", 3, "click", "label", "text"], ["iconPos", "left", "aria-description", "profile of", 3, "click", "label", "text"], ["iconPos", "left", 3, "click", "label", "text"], ["aria-description", "cart with items amount of", 3, "click", "label", "text"], ["pBadge", "", 3, "value"], ["iconPos", "left", "size", "small", "styleClass", "pds-header-bar-search-button", 3, "click", "text"], ["iconPos", "left", "size", "small", "aria-description", "profile of", 3, "click", "text"], ["iconPos", "left", "size", "small", 3, "click", "text"], ["size", "small", "aria-description", "cart with items amount of", 3, "click", "text"], [1, "pds-header-search-bar"], ["size", "small", "severity", "secondary", "aria-description", "close search", 3, "click", "text"], [1, "pds-header-menu-bar", "pds-header-menu-bar-industry", 3, "ngClass"], [1, "pds-header-menu-bar", "pds-header-menu-bar-menu", 3, "ngClass"], [3, "model"], ["pTemplate", "item"], [4, "ngIf", "ngIfElse"], ["pRipple", "", "data-pc-section", "action", "tabindex", "0", 1, "flex", "align-items-center", "p-menuitem-link", 3, "target"], ["pRipple", "", "data-pc-section", "action", "tabindex", "0", 1, "flex", "align-items-center", "p-menuitem-link", 3, "target", "routerLink"], [1, "p-menuitem-text"]],
        template: function HeaderBarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c1);
            i0.ɵɵtemplate(0, HeaderBarComponent_div_0_Template, 20, 16, "div", 5)(1, HeaderBarComponent_div_1_Template, 5, 4, "div", 6)(2, HeaderBarComponent_div_2_Template, 2, 4, "div", 7)(3, HeaderBarComponent_div_3_Template, 3, 4, "div", 8)(4, HeaderBarComponent_ng_template_4_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(6, HeaderBarComponent_ng_template_6_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.showSearchBar);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showSearchBar && ctx.showSearch);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.industryName);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.menuItems && ctx.menuItems.length > 0);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, ButtonModule, i2.Button, i3.PrimeTemplate, DividerModule, i4.Divider, MenubarModule, i5.Menubar, i6.RouterLink, BadgeModule, i7.BadgeDirective],
        encapsulation: 2
      });
    }
  }
  return HeaderBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { HeaderBarComponent };
